const SmsTracking = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 22 22" fill="none">
      <path
        d="M2.48813 8.02158C2.48813 5.04241 4.19051 3.76562 6.74408 3.76562H15.256C17.8096 3.76562 19.5119 5.04241 19.5119 8.02158V13.9799C19.5119 16.9591 17.8096 18.2359 15.256 18.2359H6.74408"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.256 8.44727L12.5918 10.5752C11.715 11.2732 10.2765 11.2732 9.39979 10.5752L6.74408 8.44727"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.48813 14.8311H7.59527"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.48813 11.4258H5.0417"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default SmsTracking;
